import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppThunkDispatch } from 'state/store';
import { Checkbox } from '@getsynapse/design-system';
import {
  toggleSelectAllTasks,
  selectAreAllTasksSelected,
  selectAreProjectTasksPartiallySelected,
} from 'state/ProjectTasksList/export/exportSlice';

interface SelectAllRowsCheckboxProps {
  isListEmpty?: boolean;
}

const SelectAllRowsCheckbox: FC<SelectAllRowsCheckboxProps> = ({
  isListEmpty = false,
}) => {
  const dispatch = useAppThunkDispatch();
  const areAllTasksSelected = useSelector(selectAreAllTasksSelected);
  const areProjectTasksPartiallySelected = useSelector(
    selectAreProjectTasksPartiallySelected
  );
  const checked = areProjectTasksPartiallySelected
    ? 'mixed'
    : areAllTasksSelected && !isListEmpty;

  const toggleAllRowsSelected = useCallback(() => {
    dispatch(toggleSelectAllTasks());
  }, [dispatch]);

  return (
    <Checkbox
      onChange={toggleAllRowsSelected}
      label=''
      inputProps={{
        className: 'mr-0 mt-0',
      }}
      checked={checked}
    />
  );
};

export default SelectAllRowsCheckbox;
